import React from 'react';

import { usePackage } from './packageProvider';

export default function PDFViewer() {
  const { packagesData, currentPkgNum } = usePackage();

  if (
    !packagesData
    || packagesData.length === 0
    || !packagesData[currentPkgNum - 1]?.packingSlipUrl
  ) {
    return <div>No packing slip available.</div>;
  }

  const url = packagesData[currentPkgNum - 1]?.packingSlipUrl;

  return url ? (
    <iframe
      src={url}
      width="100%"
      height="100%"
      style={{ border: 'none' }}
      title="PDF Viewer"
    />
  ) : null;
}
